module.exports = __webpack_public_path__ + "img/sec1_box6.4cee8fcc.jpg";